"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
exports.getPairPrice = (assetPair) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    //@todo: should be moved to config
    const krakenAPIEndpoint = 'https://api.kraken.com/';
    const response = yield axios_1.default.get(krakenAPIEndpoint + '0/public/Ticker?pair=' + assetPair);
    const data = response.data;
    if (data.error.length >= 1) {
        throw new Error(data.error[0]);
    }
    const number = Number((_c = (_b = (_a = data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b[assetPair]) === null || _c === void 0 ? void 0 : _c.p[0]);
    if (!number) {
        throw new Error('no price found');
    }
    return number;
});
exports.getPairOfferAveragePrice = (sellAssetCode, buyAssetCode) => __awaiter(void 0, void 0, void 0, function* () {
    //@todo: should average something like https://laboratory.stellar.org/#explorer?resource=trade_aggregations&endpoint=all&values=eyJiYXNlX2Fzc2V0Ijp7InR5cGUiOiJuYXRpdmUiLCJjb2RlIjoiIiwiaXNzdWVyIjoiIn0sImNvdW50ZXJfYXNzZXQiOnsidHlwZSI6ImNyZWRpdF9hbHBoYW51bTQiLCJjb2RlIjoiQlRDIiwiaXNzdWVyIjoiR0NOU0dIVUNHNVZNR0xUNVJJWVlaU083VlFVTFFLQUo2MlFBMzNEQkM1UFBCU081N0xGV1ZWNlAifSwiZW5kX3RpbWUiOiIxNjE4MzAwOTQwMDAwIiwic3RhcnRfdGltZSI6IjE2MTgyMTQ1NDAwMDAiLCJyZXNvbHV0aW9uIjoiNjAwMDAifQ%3D%3D&network=public
    throw new Error('not implemented yet');
    // const { server, currencies } = getConfig();
    // const sellAsset = new Asset(currencies[sellAssetCode].asset_code, currencies[sellAssetCode].issuer);
    // const buyAsset = new Asset(currencies[buyAssetCode].asset_code, currencies[buyAssetCode].issuer);
    // server.tradeAggregation().selling(sellAsset).buying(buyAsset);
});
//# sourceMappingURL=priceService.js.map